// src/pages/stock/categories/hooks/useLogic.js
import { useContext, useState, useEffect, useCallback } from 'react';
import AuthContext from '../../../contexts/authContext';
import { getAPI, postAPI, putAPI, deleteAPI } from '../../../apis/backend/apiNode';

export const useLogicProduit = () => {
	const { userData } = useContext(AuthContext);
	const [data, setData] = useState([]);
	const [pagination, setPagination] = useState({
		current_page: 1,
		total_pages: 1,
		total: 0,
		perPage: 10,
	});
	const [error, setError] = useState(null);
	const [spinner, setSpinner] = useState(false);
	const [perPage, setPerPage] = useState(10);

	const loadData = useCallback(
		async (page = 1) => {
			setSpinner(true);
			setError(null);
			try {
				const response = await getAPI('stock', `/produits?page=${page}&limit=${perPage}`);
				if (response?.success) {
					// FIX: Changed from categories to produits
					setData(response.data.produits || []);
					setPagination({
						current_page: response.data.page || 1,
						total_pages: response.data.totalPages || 1,
						total: response.data.total || 0,
						perPage,
					});
				} else {
					setError(response?.error || 'Erreur lors du chargement');
				}
			} catch (err) {
				setError(err.message);
			} finally {
				setSpinner(false);
			}
		},
		[perPage],
	);

	const searchProduits = useCallback(
		async (term, page = 1) => {
			if (!term.trim()) {
				loadData(page);
				return;
			}
			setSpinner(true);
			setError(null);
			try {
				const response = await getAPI(
					'stock',
					`/produits/recherche?term=${encodeURIComponent(
						term,
					)}&page=${page}&limit=${perPage}`,
				);
				if (response?.success) {
					setData(response.data.produits || []);
					setPagination({
						current_page: response.data.page || 1,
						total_pages: response.data.totalPages || 1,
						total: response.data.total || 0,
						perPage,
					});
				} else {
					setError(response?.error || 'Erreur lors de la recherche');
				}
			} catch (err) {
				setError(err.message);
			} finally {
				setSpinner(false);
			}
		},
		[perPage, loadData],
	);

	const createProduit = useCallback(async (produitData) => {
		try {
			const result = await postAPI('stock', produitData, '/produits');
			return result || { success: false, error: 'No response from server' };
		} catch (err) {
			console.error('Create Produit error:', err);
			return { success: false, error: err.message };
		}
	}, []);

	const updateProduit = useCallback(async (id, produitData) => {
		try {
			const result = await putAPI('stock', produitData, `/produits/${id}`);
			return result || { success: false, error: 'No response from server' };
		} catch (err) {
			console.error('Update Produit error:', err);
			return { success: false, error: err.message };
		}
	}, []);

	const deleteProduit = useCallback(async (id) => {
		try {
			const result = await deleteAPI('stock', `/produits/${id}`);
			return result || { success: false, error: 'No response from server' };
		} catch (err) {
			console.error('Delete Produit error:', err);
			return { success: false, error: err.message };
		}
	}, []);

	const handlePageChange = useCallback(
		(newPage) => {
			loadData(newPage);
		},
		[loadData],
	);

	const handlePerPageChange = useCallback(
		(newPerPage) => {
			setPerPage(newPerPage);
			loadData(1);
		},
		[loadData],
	);

	useEffect(() => {
		loadData(1);
	}, [loadData]);

	return {
		data,
		pagination,
		error,
		spinner,
		loadData,
		createProduit,
		updateProduit,
		deleteProduit,
		searchProduits,
		handlePageChange,
		handlePerPageChange,
	};
};
